import Button from "../../components/updatedComponents/Dealers/Button";
import { ProgressBar } from "../../components/updatedComponents/Production/ProgressBar";
import styles from "./Production.module.css";

const MobileProductionCard = ({ item, mode, onUpdate }) => {
  return (
    <div
      className={`${styles.mobileCard} ${mode ? styles.mobileCardDark : ""}`}
      onClick={() => onUpdate(item)}
    >
      <div className={styles.mobileCardHeader}>
        <div>
          <strong>{item.itemCode}</strong>
          <p className={styles.mobileSubTitle}>{item.voucherNo}</p>
        </div>

        <span className={styles.statusBadge}>{item.status}</span>
      </div>

      <div className={styles.mobileRow}>
        <span>Required Qty</span>
        <span>{item.requiredQty}</span>
      </div>

      <div className={styles.mobileRow}>
        <span>Produced Qty</span>
        <span style={{ color: "#12B76A", fontWeight: 700 }}>
          {item.producedQty}
        </span>
      </div>

      <div className={styles.mobileRow}>
        <span>Pending Qty</span>
        <span
          style={{
            color: item.pendingQty > 0 ? "#F04438" : "#12B76A",
            fontWeight: 700,
          }}
        >
          {item.pendingQty}
        </span>
      </div>

      <div className={styles.mobileRow}>
        <span>Machine</span>
        <span>{item.machine}</span>
      </div>

      <div style={{ marginTop: 12 }}>
        <ProgressBar
          produced={item.producedQty}
          required={item.requiredQty}
          mode={mode}
        />
      </div>
      <div style={{ marginTop: 12 }}>
        <Button
          buttonBgColor={"#4164E3"}
          buttonTextColor={"#ffffff"}
          buttonText={"Update Production"}
          buttonClick={(e) => {
            e.stopPropagation();
            onUpdate(item);
          }}
        />
      </div>
    </div>
  );
};

export default MobileProductionCard;
